import { SelectItem as AriakitSelectItem, type SelectItemProps } from '@ariakit/react/select';
import cn from 'classnames';
import { Spinner } from '#assets/Spinner.tsx';
import styles from './SelectItemLoading.module.css';

type Props = {
  children: React.ReactNode;
  className?: string;
} & SelectItemProps;

export function SelectItemLoading({ children, className, ...props }: Props) {
  return (
    <AriakitSelectItem className={styles.SelectItemLoading} disabled={true} {...props}>
      {/* mr-16 balances out the padding difference between left and right, to properly center. */}
      <span className={cn('truncate grow mr-16 center', className)}>
        <Spinner className={styles.SelectItemLoading_spinner} size={16} aria-hidden={true} />
        {children}
      </span>
    </AriakitSelectItem>
  );
}
